import { observer } from 'mobx-react-lite';
import type { ViewType } from 'owa-calendar-actions';
import { FullItemLoadState, getFullItemLoadState } from 'owa-calendar-events-store';
import DataRow from 'owa-calendar-forms-common/lib/components/DataRow';
import InlineLocations from 'owa-calendar-forms-common/lib/components/InlineLocations';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import { locationAccessibility } from 'owa-locstrings/lib/strings/locationaccessibility.locstring.json';
import * as React from 'react';
import {
    lazyOpenMobilityCompose,
    lazyCanTravelToEvent,
    MobilityAddTravelTime,
} from 'owa-mobility-compose';

const styles = require('./CalendarItemPeek.scss');

interface PeekEventLocationRowProps {
    item: CalendarEvent;
    colorScheme: ColorScheme;
    actionSource: ViewType;
}

export default observer(function PeekEventLocationRow(props: PeekEventLocationRowProps) {
    const { item, colorScheme, actionSource } = props;

    const locations = item?.Locations;
    const disableCards = getFullItemLoadState(item.ItemId.Id) == FullItemLoadState.Loading;

    const onAddTravelTimeButtonClick = React.useCallback(() => {
        lazyOpenMobilityCompose.importAndExecute(item);
    }, [item]);

    let showTravelTimeButton = false;
    if (isFeatureEnabled('cal-mf-mobility')) {
        const canTravelToEvent = lazyCanTravelToEvent.tryImportForRender();
        showTravelTimeButton = canTravelToEvent?.(item);
    }

    return (
        <DataRow
            className={styles.locationRow}
            iconName={ControlIcons.POI}
            iconClassName={styles.whereIcon}
            childrenAriaLabel={loc(locationAccessibility)}>
            <div className={styles.locationContainer}>
                {
                    <>
                        <InlineLocations
                            locations={locations}
                            actionSource={actionSource}
                            isOrganizer={item.IsOrganizer}
                            isMeeting={item.IsMeeting}
                            className={styles.locationValue}
                            colorScheme={colorScheme}
                            disableCards={disableCards}
                            resources={item.Resources}
                            isRoomRequested={item.IsRoomRequested}
                            autoRoomBookingStatus={item.AutoRoomBookingStatus}
                        />
                        {showTravelTimeButton && (
                            <MobilityAddTravelTime
                                className={styles.addTravelTimeButton}
                                onClick={onAddTravelTimeButtonClick}
                                colorScheme={colorScheme}
                            />
                        )}
                    </>
                }
            </div>
        </DataRow>
    );
});
